<template>
    <div class="dataManage">
      <div class="topButton">
        <div class="other">
          <el-button type="primary" @click="filterFind">组合筛选查找</el-button>
        </div>

        <div class="search">
          <el-input v-model="findNumber" placeholder="请输入要查找的编号" clearable></el-input>
          <el-button type="primary" @click="searchCase">查找该案例</el-button>
          <el-button type="primary" @click="getTables(pageInfo.currentPage,pageInfo.pageSize)">返回</el-button>
        </div>
      </div>
      <rtas-all></rtas-all>
      <rtas-find v-if="update"></rtas-find>
      <div class="mainTable" ref="date">
        <!--表格组件-->
        <el-table ref="naisData" tooltip-effect="dark" border highlight-current-row  :data="tableData" :height="tableHeight" :max-height="tableHeight" :key="table" v-loading="loading">
          <el-table-column v-for="(item,index) in tableTitle" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="220" align="center" v-if="userType === '1'">
            <template slot-scope="scope" >
              <el-button size="mini" @click="getEdit(scope.$index,scope.row)" type="info">编辑</el-button>
              <el-button size="mini" @click="getAllMsg(scope.$index,scope.row)" type="primary">详情</el-button>
              <el-button size="mini" @click="deleteCase(scope.$index,scope.row)" type="danger">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="160" align="center" v-if="userType === '2'">
            <template slot-scope="scope" >
              <el-button size="mini" @click="getEdit(scope.$index,scope.row)" type="info">编辑</el-button>
              <el-button size="mini" @click="getAllMsg(scope.$index,scope.row)" type="primary">详情</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="100" align="center"  v-if="userType === '3'">
            <template slot-scope="scope">
              <el-button size="mini" @click="getAllMsg(scope.$index,scope.row)" type="primary">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页器-->
        <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfo.currentPage" :page-size="pageInfo.pageSize" :total="pageInfo.totalCount" @size-change="handleSizeChange" :page-sizes="[5, 10, 20, 30]" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
</template>

<script>
  import bus from './bus'
  import rtasAll from './allMsg'
  import rtasFind from './comboDialog'

  export default {
    name: "数据管理",
    components:{
      rtasAll,
      rtasFind
    },
    data(){
      return{
        /*是否启用数据筛选*/
        choose:false,
        /*用来筛选的数据*/
        chooseData:{},
        /*更新查找组件*/
        update:true,
        /*加载动画*/
        loading:true,
        /*用户菜单栏权限*/
        userType:localStorage.user,
        /*查找的案例编号*/
        findNumber:'',
        /*多选时标记当前行的标记*/
        idKey: "caseNumber",
        /*通过key刷新表格*/
        table:1,
        /*分页器的参数*/
        pageInfo: {
          currentPage: 1,
          pageSize: 10,
          totalCount:0
        },
        /*表格的最大高度*/
        tableHeight:'',
        /*表格组件渲染数组*/
        tableTitle:[
          {label:"案例编号",width:"120",prop:"caseNumber",show:false},
          {label:"数据完整状态",width:"120",prop:"isComplete",show:false},
          {label:"参与方总数",width:"120",prop:"participantsNum",show:false},
          {label:"参与方类别",width:"130",prop:"typeOfParticipants",show:true},
          {label:"场景类别",width:"130",prop:"typeOfScene",show:true},
          {label:"事故形态",width:"130",prop:"accidentForm",show:true},
          {label:"事故具体类型",width:"130",prop:"accidentType",show:true},
          {label:"障碍物类型",width:"130",prop:"obstacleType",show:true},
          {label:"天网及其他视频",width:"130",prop:"otherVideo",show:true},
          {label:"事故分类",width:"130",prop:"classificationOfAccidents",show:true},
          {label:"路段信息",width:"130",prop:"roadInformation",show:true},
          {label:"天气",width:"130",prop:"weather",show:false},
          {label:"事故发生时段",width:"130",prop:"periodOfAccident",show:true},
          {label:"参与方一类型",width:"150",prop:"typeOfParticipant0",show:true},
          {label:"参与方一行驶方式",width:"150",prop:"vehicleTravelled0",show:true},
          {label:"参与方一主要过错",width:"150",prop:"mainAccidentCause0",show:true},
          {label:"参与方一道路路口信号灯",width:"180",prop:"intersectionSignalLamp0",show:true},
          {label:"参与方二类型",width:"150",prop:"typeOfParticipant1",show:true},
          {label:"参与方二行驶方式",width:"150",prop:"vehicleTravelled1",show:true},
          {label:"参与方二主要过错",width:"150",prop:"mainAccidentCause1",show:true},
          {label:"参与方二道路路口信号灯",width:"180",prop:"intersectionSignalLamp1",show:true},
        ],
        /*表格数据*/
        tableData: [

        ],
      }
    },
    methods:{
      /* 分页大小切换*/
      handleSizeChange(val) {
        this.pageInfo.pageSize = val;
        this.getTable(this.pageInfo.currentPage,this.pageInfo.pageSize);
      },
      /*分页切换*/
      handleCurrentChange(val) {
        this.pageInfo.currentPage = val;
        this.getTable(this.pageInfo.currentPage,this.pageInfo.pageSize);
      },
      /*获取高度*/
      getHeight(){
        /*定义两个高度，初始高度和现在高度*/
        let nowH;
        /*延迟获取当前高度*/
        this.$nextTick(()=>{
          nowH = this.$refs.date.offsetHeight - 36;
        });
        let height = this.tableHeight;
        /*比对操作*/
        if(nowH !== height){
          this.tableHeight = nowH;
          this.table++;
        }
      },
      /*渲染表格数据*/
      getTable(pageNo,pageSize){
        this.loading = true;
        let postData = {};
        if(this.choose === true){
          for(let key of Object.keys(this.chooseData)){
            postData[key] = this.chooseData[key];
          }
          let pageNoName = 'pageNo';
          let pageSizeName = 'pageSize';
          postData[pageNoName] = pageNo;
          postData[pageSizeName] = pageSize;
        }
        else{
          postData ={
            "pageNo":pageNo,
            "pageSize":pageSize,
          };
        }
        this.$http.post(
          '/total/total/sc',
          postData
        )
          .then((res) => {
            let data = res.data;
            let tableData = [];
            this.pageInfo.totalCount = res.totalCount;
            for(let i = 0; i <data.length; i++){
              let obj = {};
              for(let key of Object.keys(data[i])){
                obj[key] = data[i][key];
              }
              tableData[i] = obj;
            }
            this.tableData = tableData;
            this.$nextTick(
              this.loading = false,
            );
          })
          .catch ((err) => {
            console.log(err);
          })
      },
      /*查看原来的表格*/
      getTables(pageNo,pageSize){
        this.choose = false;
        this.getTable(pageNo,pageSize);
      },
      /*查找案例*/
      searchCase(){
        this.$http.get(
          '/total/total/mt/' + this.findNumber
        )
          .then((res) => {
            let obj = {};
            for(let key of Object.keys(res)){
              obj[key] = res[key];
            }
            this.tableData = [];
            this.tableData[0] = obj;
            this.findNumber = '';
          })
          .catch ((err) => {
            console.log(err);
          })
      },
      /*删除案例*/
      deleteCase(index,row){
        this.$confirm('确定要删除吗?', '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=> {
          this.$http.delete(
            '/total/total/' + row.id
          )
            .then((res) => {
              this.$delete(this.tableData,index);
              this.$message({
                message:"删除成功",
                type:'success',
                center:true,
                duration:1500
              });
              this.pageInfo.totalCount--;
            })
            .catch((err)=>{
              console.log(err);
            })
        });
      },
      /*打开详情页面*/
      getAllMsg(index,row){
        /*打开页面*/
        bus.$emit("visible");
        /*设置不可编辑模式*/
        bus.$emit("disable");
        /*发送请求获取数据*/
        this.$http.get(
          '/total/total/' + row.id
        )
          .then((res)=>{
            bus.$emit("allData",res);
          })
          .catch((err)=>{
            console.log(err);
          })
      },
      /*打开编辑页面*/
      getEdit(index,row){
        /*打开页面*/
        this.getAllMsg(index,row);
        /*显示修改按钮*/
        bus.$emit("edit");
        /*渲染完毕后修改为可修改*/
        this.$nextTick(()=>{
          bus.$emit("change");
        });
      },
      /*筛选查找界面控制开关*/
      filterFind(){
        bus.$emit('filterFind');
      }
    },
    mounted(){
      this.$nextTick(()=>{
        this.tableHeight = this.$refs.date.offsetHeight - 36;
      });
    },
    created(){
      /*在页面初始化时调用获取实时高度函数*/
      this.getHeight();
      this.getTable(1,10);
      /*获取到查询结果之后*/
      bus.$on('getResult',(msg)=>{
        this.chooseData = msg;
        this.choose = true;
        this.getTable(1,10);
        this.update = false;
        this.$nextTick(() => {
          this.update = true;
        })
      });
    }
  }
</script>

<style scoped>
  .dataManage{
    width: 100%;
    height: calc(100% - 34px);
  }
  .topButton{
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    background-color: #E9EBEE;
  }
  .other{
    margin-left: 2%;
    display: flex;
    align-items: center;
    width: 58%;
    height: 100%;
  }
  .search{
    width: 30%;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .search .el-input{
    width: 60%;
  }
  .search .el-button{
    height: 40px;
    margin-left: 10px;
  }
  .mainTable{
    width: 100%;
    height: calc(100% - 50px);
  }
  .el-pagination{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/data/dataManage.vue